import { useEffect } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "dd_ref";
const DAYS = 30;

/** Ambassador code that should be credited at checkout (null when none / expired). */
export const getRef = () => getRefInfo()?.code || null;

/** {code, name} of the ambassador whose link brought this shopper, or null. */
export const getRefInfo = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!raw?.code || Date.now() > raw.exp) return null;
    return { code: raw.code, name: raw.name || null };
  } catch {
    return null;
  }
};

/** Captures ?ref=CODE on any page, keeps it for 30 days (through checkout) and counts the click. */
export const RefCapture = () => {
  const { search } = useLocation();
  useEffect(() => {
    const code = new URLSearchParams(search).get("ref");
    if (!code) return;
    const clean = code.trim().toUpperCase().slice(0, 24);
    const exp = Date.now() + DAYS * 864e5;
    localStorage.setItem(KEY, JSON.stringify({ code: clean, exp }));
    axios.post(`${API}/ambassadors/click`, { code: clean, path: window.location.pathname }).then((r) => {
      if (!r.data.valid) localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, JSON.stringify({ code: r.data.code || clean, name: r.data.name, exp }));
    }).catch(() => {});
  }, [search]);
  return null;
};
